import { Broker, CodeDeployment } from "@amzn/amazonmq-opsconsole-client";
import useConfig from "../../../../hooks/useConfig";
import { Link, SpaceBetween, Spinner, StatusIndicator } from "@amzn/awsui-components-react";
import { createIsengardLink } from "../../../../utils";


interface Props {
    instanceId: string;
    deployments: CodeDeployment[];
    broker: Broker;
}

const CodeDeployments: React.FC<Props> = ({instanceId, deployments, broker}) => {
    const config = useConfig();
    
    if (!config) {
        return <Spinner />;
    }
    
    const instanceDeployments = deployments.filter(deployment => 
        deployment.instanceIds && deployment.instanceIds.includes(instanceId)
    );
    
    if (instanceDeployments.length === 0) {
        return <div>No deployments</div>;
    }
    
    return (
        <SpaceBetween direction="vertical" size="xs">
            {instanceDeployments.map((deployment, index) => (
                <div key={index}>
                    <SpaceBetween direction="horizontal" size='s'>
                    <Link 
                        target="_blank"
                        external href={createIsengardLink(
                            config.isengardEndpoint, 
                            broker.brokerInfo.cellAccountId, 
                            'ReadOnly', 
                            `codesuite/codedeploy/deployments/${deployment.deploymentId}?region=${config.region}`
                        )}
                    >
                        {deployment.deploymentId}
                    </Link>
                    <StatusIndicator 
                        type={
                            deployment.status === 'Succeeded' ? 'success' : 
                            deployment.status === 'Failed' ? 'error' : 
                            deployment.status === 'InProgress' ? 'in-progress' : 'warning'
                        }
                    >
                        {deployment.status}
                    </StatusIndicator>
                    </SpaceBetween>
                </div>
            ))}
        </SpaceBetween>
    );
}

export default CodeDeployments